import { unset } from 'lodash'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export default class Header extends Component {
	constructor(props) {
		super(props)
		this.state = {

		}
	}
	render() {
		return (
			<div>
				<nav className='navbar navbar-expand navbar-white navbar-light justify-content-end' >
					<select value={this.props.appLanguage} onChange={(e) => this.props.changeAppLanguage(e)} class="form-select col-md-3" aria-label="Default select example">
						<option key={'default'} value={''} >
							{'Choose Language'}
						</option>
						<option value="Telugu">Telugu</option>
						<option value="English">English</option>
						<option value="Hindi">Hindi</option>
					</select>

				</nav>
			</div>
		)
	}
}
